export default __webpack_public_path__ + "static/media/IconCross.5fdeb5cf.svg";